export default "__VITE_ASSET__UYrQM_Uh__"